<template>
  <button class="c-button c-button--youtube" v-on="$listeners">
    <font-awesome-icon :icon="['fab', 'youtube']" class="c-button__left-icon"></font-awesome-icon>
    Connect & Subscribe
  </button>
</template>
<script>
export default {
}
</script>
